"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ofTypeFromDirectives = exports.directiveArgValueToTypeReference = void 0;
const ramda_1 = require("ramda");
function isDirectiveObject(value) {
    return !!ramda_1.path(["fields"], value);
}
function directiveArgValueToTypeReference(argValue) {
    if (typeof argValue === "string") {
        return [
            {
                kind: "reference",
                directives: [],
                name: argValue,
            },
        ];
    }
    if (isDirectiveObject(argValue)) {
        return argValue.fields.map((field) => ({
            kind: "reference",
            name: field.name,
            directives: [],
            of: directiveArgValueToTypeReference(field.value),
        }));
    }
    return [];
}
exports.directiveArgValueToTypeReference = directiveArgValueToTypeReference;
function argToGeneric(arg) {
    return {
        name: arg.name,
        extends: ramda_1.head(directiveArgValueToTypeReference(arg.value)),
    };
}
const genericsDirectiveName = "generics";
function genericsFromDirectives(directives) {
    const genericsDirective = directives.find((d) => d.name === genericsDirectiveName);
    return {
        generics: ((genericsDirective === null || genericsDirective === void 0 ? void 0 : genericsDirective.arguments.fields) || []).map(argToGeneric),
        otherDirectives: directives.filter((d) => d.name !== genericsDirectiveName),
    };
}
exports.default = genericsFromDirectives;
const ofTypeDirectiveName = "of";
function ofTypeFromDirectives(directives) {
    const ofTypeDirective = directives.find((d) => d.name === ofTypeDirectiveName);
    return {
        of: (ofTypeDirective === null || ofTypeDirective === void 0 ? void 0 : ofTypeDirective.arguments) &&
            directiveArgValueToTypeReference(ofTypeDirective.arguments),
        otherDirectives: directives.filter((d) => d.name !== ofTypeDirectiveName),
    };
}
exports.ofTypeFromDirectives = ofTypeFromDirectives;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2VuZXJpY3NGcm9tRGlyZWN0aXZlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy92Mi9wYXJzZXJzL2dmU2RsL2dlbmVyaWNzRnJvbURpcmVjdGl2ZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsaUNBQW1DO0FBWW5DLFNBQVMsaUJBQWlCLENBQUMsS0FBVztJQUNwQyxPQUFPLENBQUMsQ0FBQyxZQUFJLENBQUMsQ0FBQyxRQUFRLENBQUMsRUFBRSxLQUFLLENBQUMsQ0FBQztBQUNuQyxDQUFDO0FBRUQsU0FBZ0IsZ0NBQWdDLENBQzlDLFFBQWdDO0lBRWhDLElBQUksT0FBTyxRQUFRLEtBQUssUUFBUSxFQUFFO1FBQ2hDLE9BQU87WUFDTDtnQkFDRSxJQUFJLEVBQUUsV0FBVztnQkFDakIsVUFBVSxFQUFFLEVBQUU7Z0JBQ2QsSUFBSSxFQUFFLFFBQVE7YUFDZjtTQUNGLENBQUM7S0FDSDtJQUNELElBQUksaUJBQWlCLENBQUMsUUFBUSxDQUFDLEVBQUU7UUFDL0IsT0FBTyxRQUFRLENBQUMsTUFBTSxDQUFDLEdBQUcsQ0FBc0IsQ0FBQyxLQUFLLEVBQUUsRUFBRSxDQUFDLENBQUM7WUFDMUQsSUFBSSxFQUFFLFdBQVc7WUFDakIsSUFBSSxFQUFFLEtBQUssQ0FBQyxJQUFJO1lBQ2hCLFVBQVUsRUFBRSxFQUFFO1lBQ2QsRUFBRSxFQUFFLGdDQUFnQyxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUM7U0FDbEQsQ0FBQyxDQUFDLENBQUM7S0FDTDtJQUNELE9BQU8sRUFBRSxDQUFDO0FBQ1osQ0FBQztBQXJCRCw0RUFxQkM7QUFFRCxTQUFTLFlBQVksQ0FBQyxHQUF5QjtJQUM3QyxPQUFPO1FBQ0wsSUFBSSxFQUFFLEdBQUcsQ0FBQyxJQUFJO1FBQ2QsT0FBTyxFQUFFLFlBQUksQ0FBQyxnQ0FBZ0MsQ0FBQyxHQUFHLENBQUMsS0FBSyxDQUFDLENBQUM7S0FDM0QsQ0FBQztBQUNKLENBQUM7QUFNRCxNQUFNLHFCQUFxQixHQUFHLFVBQVUsQ0FBQztBQUV6QyxTQUF3QixzQkFBc0IsQ0FDNUMsVUFBZ0M7SUFFaEMsTUFBTSxpQkFBaUIsR0FBRyxVQUFVLENBQUMsSUFBSSxDQUN2QyxDQUFDLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQyxDQUFDLElBQUksS0FBSyxxQkFBcUIsQ0FDeEMsQ0FBQztJQUVGLE9BQU87UUFDTCxRQUFRLEVBQUUsQ0FBQyxDQUFBLGlCQUFpQixhQUFqQixpQkFBaUIsdUJBQWpCLGlCQUFpQixDQUFFLFNBQVMsQ0FBQyxNQUFNLEtBQUksRUFBRSxDQUFDLENBQUMsR0FBRyxDQUFDLFlBQVksQ0FBQztRQUN2RSxlQUFlLEVBQUUsVUFBVSxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQyxDQUFDLElBQUksS0FBSyxxQkFBcUIsQ0FBQztLQUM1RSxDQUFDO0FBQ0osQ0FBQztBQVhELHlDQVdDO0FBRUQsTUFBTSxtQkFBbUIsR0FBRyxJQUFJLENBQUM7QUFFakMsU0FBZ0Isb0JBQW9CLENBQ2xDLFVBQWdDO0lBRWhDLE1BQU0sZUFBZSxHQUFHLFVBQVUsQ0FBQyxJQUFJLENBQ3JDLENBQUMsQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFDLENBQUMsSUFBSSxLQUFLLG1CQUFtQixDQUN0QyxDQUFDO0lBRUYsT0FBTztRQUNMLEVBQUUsRUFDQSxDQUFBLGVBQWUsYUFBZixlQUFlLHVCQUFmLGVBQWUsQ0FBRSxTQUFTO1lBQzFCLGdDQUFnQyxDQUFDLGVBQWUsQ0FBQyxTQUFTLENBQUM7UUFDN0QsZUFBZSxFQUFFLFVBQVUsQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDLEVBQUUsRUFBRSxDQUFDLENBQUMsQ0FBQyxJQUFJLEtBQUssbUJBQW1CLENBQUM7S0FDMUUsQ0FBQztBQUNKLENBQUM7QUFiRCxvREFhQyJ9